module.exports = __webpack_public_path__ + "01_long_yellow.8b1398cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/01_long_yellow.png
// module id = xzos
// module chunks = 0